import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

// Actual Closing Balance is the only field on offramp_daily_summary that can't be derived
// from other collections - everything else (including Daily Expenses, now pulled from
// offramp_expenses, and Delta, now a fixed constant) is (re)computed nightly by the 23:55
// IST cron. This dialog is how an admin enters/corrects that one manual input.
@Component({
    selector: 'app-edit-offramp-daily-summary',
    templateUrl: './edit-offramp-daily-summary.component.html',
    styleUrls: ['./edit-offramp-daily-summary.component.css']
})
export class EditOfframpDailySummaryDialog {
    element: any = {};
    myForm: any;
    recordId: string = '';
    dateDisplay: string = '';

    constructor(
        public dialogRef: MatDialogRef<EditOfframpDailySummaryDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public userService: UserService,
        public offrampService: OfframpService,
        private spinnerService: Ng4LoadingSpinnerService
    ) {
        this.element = data.record || {};
        this.recordId = this.element._id || '';
        this.dateDisplay = this.element.date ? moment(this.element.date).format('DD-MMM-YYYY') : '';

        this.myForm = this.fb.group({
            actualClosingBalanceINR: [this.element.actualClosingBalanceINR != null ? this.element.actualClosingBalanceINR : '']
        });
    }

    save() {
        const { notif } = defaults;

        if (this.myForm.invalid) {
            this.notifSer.error('Error', 'Please fill all required fields', notif);
            return;
        }

        this.spinnerService.show();

        const formValue = this.myForm.getRawValue();
        const formData: any = {
            _id: this.recordId,
            actualClosingBalanceINR: formValue.actualClosingBalanceINR === '' ? null : formValue.actualClosingBalanceINR,
            _csrf: this.data._csrf
        };

        this.offrampService.updateOfframpDailySummary(formData).subscribe(
            (response: any) => {
                this.spinnerService.hide();
                if (response.status || response.success) {
                    this.notifSer.success('Success', response.message || 'Offramp daily summary updated successfully', notif);
                    this.dialogRef.close({ success: true, data: response });
                } else {
                    this.notifSer.error('Error', response.message || 'Failed to update offramp daily summary', notif);
                }
            },
            (err) => {
                this.spinnerService.hide();
                this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update offramp daily summary', notif);
            }
        );
    }

    onCancel() {
        this.dialogRef.close({ success: false });
    }
}



// WEBPACK FOOTER //
// ./src/app/offramp-daily-summary/edit-offramp-daily-summary/edit-offramp-daily-summary.component.ts